<template>
  <span>
    <AppSelectCheckboxes
      v-if="
        !ignoreCheckboxesView &&
          (typeof showCheckboxesView === 'function'
            ? showCheckboxesView()
            : showCheckboxesView)
      "
      v-model="givenValue"
      :items="horesTypes"
      box-outlined
      v-bind="$attrs"
    />
    <v-select
      v-else
      v-model="givenValue"
      v-show-fade="{ isFilter: isFilter }"
      v-bind="$attrs"
      :menu-props="menuProperties"
      :items="horesTypes"
      :hide-details="hideDetails"
      outlined
      :clearable="clearable"
      :class="[selectMixinClass]"
      @change="inputVisibility($event, 'change')"
      @focus="focused"
      @blur="inputVisibility"
    />
  </span>
</template>
<script>
import { computed, unref } from "vue";
import gql from "fraql";
import AppSelectCheckboxes from "./AppSelectCheckboxes.vue";
import selectsMixin from "./selects_mixin.js";
export default {
  name: "AppSelectHorseTypes",
  components: { AppSelectCheckboxes },
  mixins: [selectsMixin],
  props: {
    hideDetails: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      ponyTypes: [],
      menuProperties: {
        minWidth: 280
      }
    };
  },
  computed: {
    givenValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    horesTypes() {
      const types = [
        {
          value: "only_horses",
          text: this.$t(
            "events:event.masterlist.HorsesPoniesFilter.horses",
            "Horses",
            "Label for horses or ponies filter horses status"
          )
        },
        {
          value: "only_ponies",
          text: this.$t(
            "events:event.masterlist.HorsesPoniesFilter.ponies",
            "Ponies",
            "Label for horses or ponies filter ponies status"
          )
        }
      ];
      this.ponyTypes.forEach(x => {
        types.push({
          value: `only_${x}_ponies`,
          text: this.$t(`events:event.masterlist.HorsesPoniesFilter.${x}ponies`)
        });
      });

      return types;
    }
  },
  created() {
    this.menuProperties.nudgeBottom = this.nudgeBottom;
  },
  apollo: {
    ponyTypes: {
      query: gql`
        query fullMasterdata {
          ponyTypes
        }
      `,
      fetchPolicy: "cache-first"
    }
  }
};
import { useHorsePonyTypesHelper } from "@composables/masterdata/ponyTypes";

export function useHorseAndPonyTypeValueHandler(filters) {
  const { horsePonyTypes } = useHorsePonyTypesHelper();

  const horseTypeFromFilter = computed(() => {
    const horseAndPonyType = unref(filters).horseAndPonyType;
    if (horseAndPonyType == "only_horses") return "horse";
    if (horseAndPonyType) return "pony";
    return null;
  });

  const ponyTypeFromFilter = computed(() => {
    const ponyType = unref(filters).horseAndPonyType;
    if (ponyType) {
      const val = ponyType.split("_")[1];
      return horsePonyTypes.value.includes(val) ? val : null;
    }
    return null;
  });

  return {
    horseTypeFromFilter,
    ponyTypeFromFilter
  };
}
</script>
